"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APDropdownIconMenu = void 0;
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var Menu_1 = __importDefault(require("@material-ui/core/Menu"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var react_1 = __importStar(require("react"));
function APDropdownIconMenu(_a) {
    var children = _a.children, options = _a.options, initial = _a.initial, onSelect = _a.onSelect;
    var _b = react_1.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClose = function () {
        setAnchorEl(null);
    };
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IconButton_1.default, { onClick: function (event) { return setAnchorEl(event === null || event === void 0 ? void 0 : event.currentTarget); } }, children),
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, options.map(function (option) {
            return react_1.default.createElement(MenuItem_1.default, { key: option, onClick: function () {
                    onSelect(option);
                    handleClose();
                } }, option);
        })));
}
exports.APDropdownIconMenu = APDropdownIconMenu;
